import styled from 'styled-components';
import { VerticalSeparator as Separator } from '../../../components/Commons/Separators/styles';
import { Modal } from 'antd';
import { QuestionCircle } from '@styled-icons/fa-regular/QuestionCircle';

export const Container = styled.div`
  width: 100%;
  min-height: 9rem;
  background-color: ${({ theme }) => theme.colors.white};
  margin: auto;
  padding: 1.5rem;
  border-radius: 0.25rem;
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.gray8};

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  & > header {
    & > h3 {
      font-size: 0.875rem;
      font-weight: 700;
      margin-bottom: 1rem;
    }
  }

  & > div.content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 1.5rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
`;

export const QuestionCircleIcon = styled(QuestionCircle)`
  width: 0.75rem;
  margin-left: 0.25rem;
`;

export const VerticalSeparator = styled(Separator)`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    display: block;
    margin: 0 0.5rem;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & .button {
    width: 16.875rem;
    margin-left: 1.5rem;
  }
`;

export const CreditModal = styled(Modal)`
  & .ant-modal-body {
    padding: unset;
  }
`;

export const RenewCreditRequestedModal = styled(Modal)`
  .ant-modal-content {
    padding: 2rem 1.5rem 1.5rem 1.5rem;
  }

  .ant-modal-body {
    padding: unset;
  }

  .ant-modal-footer {
    border-top: unset;
    padding: unset;
  }
`;
